/** Canonical manifest-backed Control Bridge home (company context resolves slug). */
export const CONTROL_BRIDGE_HOME_PATH = '/render/control-bridge';

/** Unified cross-domain hub landing (personal model manifest). */
export const UNIFIED_HUB_PATH = '/hub';

/** Alias deep link for unified hub (same page as UNIFIED_HUB_PATH). */
export const UNIFIED_HUB_RENDER_PATH = '/render/me/control-bridge';

/** Build control-bridge home href preserving query string (e.g. ?sessionId=). */
export function controlBridgeHomeHref(search = ''): string {
  if (!search) return CONTROL_BRIDGE_HOME_PATH;
  return `${CONTROL_BRIDGE_HOME_PATH}${search.startsWith('?') ? search : `?${search}`}`;
}

/** True for legacy hierarchical dashboard root only (sub-routes remain for drill-down features). */
export function isLegacyDashboardRootPath(pathname: string): boolean {
  return pathname === '/dashboard' || pathname === '/dashboard/';
}
